import React from 'react'
import './Home.css';
import { Link } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel'
import Data from "../../classes/Candidate"
import serverEndPoint from './../../dxdm';
const featureSlide = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "250pt",
    width: "100%",
    backgroundColor: "rgb(233,241,246)"
}
export default function Home() {
    return (
        <div>
            <div style={{ marginBottom: "5vh" }}>
                <div className="row" style={{ paddingTop: "20%", paddingBottom: "5%", background: `url(${serverEndPoint}/images/desktopMainBanner.png)`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundClip: "border-box" }}>
                    <div className="col-sm-6">
                    </div>
                </div>
                <div className="row" style={{ paddingLeft: "2%" }}>
                    <div className="col-sm-8">
                        <h1 style={{ color: "rgb(40,109,181)", fontWeight: "450", textAlign: "left" }}>Promoting research
                            in all aspects of Data Science</h1>
                        <p style={{ fontSize: "2vh", textAlign: "left" }}>Data Science is poised to become one of the most intensively research areas of Computer Science discipline. The Data Insight Lab at National University FAST, Islamabad focuses its research in all areas of Data Science such as Data Mining & Machine Learning, Big Data Management, Social Data Analytics, Internet of Things (IoT), and Computer Vision. We are working on cutting edge developments in these areas.</p>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row" >
                    <div className="col-xl-4" >
                        <div className="peopleSlide">
                            <Link to={`/projects`} style={{ textDecoration: "none", width: "100%" }}>
                            {/* <Link to={`${serverEndPoint}/projects`} style={{ textDecoration: "none", width: "100%" }}> */}
                                
                                <table className="col-12">
                                    <tbody>
                                        <tr>
                                            <td style={{ backgroundImage: `url(${serverEndPoint}/images/ourprojects.png)`, backgroundSize: "cover", height: "150pt" }}>

                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: "5%" }}>
                                                <h4 style={{ color: "rgb(40,108,180)", textAlign: "left" }}>Our Projects</h4>
                                                <p style={{ textAlign: "left", color: "black" }}>Read about our latest research projects and research partners.</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </Link>
                        </div>
                    </div>
                    <div className="col-xl-4" >
                        <div className="peopleSlide">
                            <Link to={`/our-research`} style={{ textDecoration: "none" }}>
                            {/* <Link to={`${serverEndPoint}/our-research`} style={{ textDecoration: "none" }}> */}
                                
                                <table className="col-12">
                                    <tbody>
                                        <tr>
                                            <td style={{ backgroundImage: `url(${serverEndPoint}/images/ourresearch.png)`, backgroundSize: "cover", height: "150pt" }}>

                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: "5%" }}>
                                                <h4 style={{ color: "rgb(40,108,180)", textAlign: "left" }}>Our Research</h4>
                                                <p style={{ textAlign: "left", color: "black" }}>We focus our research in all aspects of Data science. Click to read more details.</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Link>
                        </div>
                    </div>
                    <div className="col-xl-4" >
                        <div className="peopleSlide">
                            <Link to={`/StudyWithUs`} style={{ textDecoration: "none" }}>
                            {/* <Link to={`${serverEndPoint}/StudyWithUs`} style={{ textDecoration: "none" }}> */}
                                
                                <table className="col-12">
                                    <tbody>
                                        <tr>
                                            <td style={{ backgroundImage: `url(${serverEndPoint}/images/studywithus.png)`, backgroundSize: "cover", height: "150pt" }}>

                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: "5%" }}>
                                                <h4 style={{ color: "rgb(40,108,180)", textAlign: "left" }}>Study with us</h4>
                                                <p style={{ textAlign: "left", color: "black" }}>If you have ambition to work on a real problem in your Master or PhD, do contact us. Click to read more details.</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <h3 style={{ color: "rgb(40,109,181)", fontWeight: "450", textAlign: "left",marginLeft:"2%" }}>Latest News</h3>
            <br/>
            <div className="container">
                <div className="row">
                    <div className="col-sm-8 slider">
                        <div style={featureSlide}>
                            <Carousel variant="dark" className="col-sm-12" style={{ height: "100%" }}>

                                {
                                    Data.map(post => {
                                        return (
                                            <Carousel.Item>
                                                <div className="row" style={{ height: "250pt" }}>
                                                    <div className="col-sm-6" style={{ height: "250pt" }}>
                                                        <img className="col-12" style={{ height: "250pt" }} alt="" src={post.pic} />
                                                    </div>
                                                    <div className="col-sm-6" style={{ height: "250pt", display: "flex", alignItems: "center" }}>
                                                        <div style={{ padding: "3%" }}>
                                                            <h5 style={{ color: 'rgb(40,108,180)' }}>{post.heading}</h5>
                                                            <p > {post.info}</p>
                                                            {
                                                    post.webLink !== '' && post.webLink !== undefined &&
                                                    <a rel="noreferrer" target="_blank" href={post.webLink} style={{borderRadius:"100pt",marginTop:"5pt",paddingLeft:"5%",paddingRight:"5%"}} className="btn btn-primary">FIND OUT MORE</a>
                                                }
                                                            {
                                                    post.videoLink !== '' && post.videoLink !== undefined &&
                                                    <a rel="noreferrer" target="_blank" href={post.videoLink} style={{borderRadius:"100pt",marginTop:"5pt",paddingLeft:"5%",paddingRight:"5%"}} className="btn btn-primary">WATCH VIDEO</a>
                                                }
                                                        </div>
                                                    </div>
                                                </div>
                                            </Carousel.Item>
                                        )
                                    })
                                }
                            </Carousel>
                        </div>
                    </div>
                    <div className="col-sm-4 slider">
                        <div className="peopleSlide">
                            <Link to={`/contactus`} style={{ textDecoration: "none" }}>
                            {/* <Link to={`${serverEndPoint}/contactus`} style={{ textDecoration: "none" }}> */}
                                <div style={{ backgroundImage: `url(${serverEndPoint}/images/ourteam.png)`, backgroundSize: "cover", height: "250pt", width: "100%", paddingTop: "53%", paddingLeft: "5%", paddingRight: "5%",backgroundPosition:"center" }}>
                                    <h4 style={{ color: "rgb(40,108,180)", textAlign: 'left' }}>Contact us</h4>
                                    <p style={{ textAlign: "left", color: "black" }}>Click to contact us for any of your query about research and study.</p>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
